<div #wrapper class="upgrade-wrapper">
    <div class="modal-body">
        <div class="logo-body">
            <img class="logo" src="assets/images/logo.svg" alt="agaia logo"/>
        </div>

        <div class="upgrade-body">
            <div class="left-section section">
                <img class="upgrade-plan-img" src="assets/images/upgrade-plan.png" alt="upgrade plan"/>
            </div>
            <div class="right-section section">
                <ng-container *ngIf="getPricing() !== null">

                    <div id="yearly-pricing-toggle">
                            <span class="monthly"
                                  (click)="onYearlyPricingToggleChange(false)">
                                {{ 'billing_monthly' | localise }}
                            </span>
                        <app-toggle-switch [toggled]="showYearlyPricing"
                                           (onChange)="onYearlyPricingToggleChange($event)"></app-toggle-switch>
                        <span class="yearly"
                              (click)="onYearlyPricingToggleChange(true)"
                              [disableTooltip]="false"
                              #activeCheck="ngbTooltip"
                              placement="top-right"
                              tooltipClass="tooltip-warning"
                              ngbTooltip="{{ 'billing_saving_up_to' | localise }}"
                        >
                                {{ 'billing_yearly' | localise }}
                            </span>
                    </div>

                    <div class="card border pricing-card-body p-4"
                         [class.border-primary]="true">
                        <div class="text-center pricing-card-head">
                            <h3>{{ getPricing().title }}</h3>

                            <ng-container *ngIf="showYearlyPricing === true">
                                <h1 class="font-weight-normal pricing-amount mt-3 text-success">
                                    {{ getLanguagePricingAmount(getPricing()).yearly_price | money }}
                                    <span class="monthly-text">/ {{ 'yearly' | localise }}</span>
                                </h1>
                            </ng-container>

                            <ng-container *ngIf="showYearlyPricing === false">
                                <ng-container *ngIf="!discountCode">
                                    <h1 class="pricing-amount font-weight-normal"
                                        *ngIf="currentUserIsReferral === false || (currentUserIsReferral === true && getLanguagePricingAmount(getPricing()).discount_monthly_price.length === 0)">
                                        {{ getLanguagePricingAmount(getPricing()).monthly_price | money }}
                                        <span class="monthly-text">/ {{ 'monthly' | localise }}</span>
                                    </h1>

                                    <h1 class="pricing-amount font-weight-normal"
                                        *ngIf="getLanguagePricingAmount(getPricing()).discount_monthly_price.length > 0 && currentUserIsReferral === true">
                                        {{ getLanguagePricingAmount(getPricing()).discount_monthly_price | money }}
                                        <span class="monthly-text">/ {{ 'monthly' | localise }}</span>
                                    </h1>

                                    <h1 class="pricing-amount font-weight-normal"
                                        *ngIf="getLanguagePricingAmount(getPricing()).discount_monthly_price.length > 0 && currentUserIsReferral === true">
                                        <del style="color: #e81616; font-size: 1.3rem;">{{ getLanguagePricingAmount(getPricing()).monthly_price | money }}</del>
                                        <span class="monthly-text">/ {{ 'monthly' | localise }}</span>
                                    </h1>
                                </ng-container>

                                <ng-container *ngIf="discountCode">
                                    <h1 class="font-weight-normal">
                                        <span style="color: #0e900e;">{{ getLanguagePricingAmount(getPricing()).monthly_price | money }}</span>
                                        <span class="monthly-text">/ {{ 'monthly' | localise }}</span>
                                    </h1>
                                </ng-container>
                            </ng-container>
                        </div>

                        <ul class="list-unstyled plan-features">
                            <li *ngFor="let feature of getPricing().features">
                                <i class="fa fa-check-circle"></i>
                                {{ feature.title }}
                            </li>
                        </ul>

                        <div class="pricing-buttons wrapper">
                            <button
                                    class="btn btn-block"
                                    [class.btn-primary]="true"
                                    (click)="onChoose()"
                            >
                                {{ 'choose' | localise }}
                            </button>
                            <button class="btn btn-block btn-outline-info" (click)="bsModalRef.hide()">
                                {{ 'cancel' | localise }}
                            </button>

                            <button *ngIf="discountCode" class="btn btn-block btn-outline-light">
                                {{ 'code' | localise }} {{ discountCode.code }}
                            </button>
                        </div>
                    </div>

                </ng-container>
            </div>
        </div>
    </div>
</div>
